<div class="date-range-filter" [formGroup]="dateRangeForm">
  <mat-button-toggle-group class="toggle-buttons" formControlName="day">
    <mat-button-toggle value="3000">Все время</mat-button-toggle>
    <mat-button-toggle value="1">Сутки</mat-button-toggle>
    <mat-button-toggle value="7">Неделя</mat-button-toggle>
    <mat-button-toggle value="30">Месяц</mat-button-toggle>
  </mat-button-toggle-group>

  <span>или</span>

  <div class="picker-range">
    <mat-form-field appearance="fill" class="calendar-date-range">
      <input matInput [ngxMatDatetimePicker]="pickerStart" placeholder="Choose start" formControlName="start">
      <mat-datepicker-toggle matSuffix [for]="$any(pickerStart)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #pickerStart [showSpinners]="true"></ngx-mat-datetime-picker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="calendar-date-range">
      <input matInput [ngxMatDatetimePicker]="pickerEnd" (dateChange)="changeEndPickerDate()" placeholder="Choose end"
             formControlName="end">
      <mat-datepicker-toggle matSuffix [for]="$any(pickerEnd)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #pickerEnd [showSpinners]="true"></ngx-mat-datetime-picker>
    </mat-form-field>
  </div>
  <!--  <mat-form-field appearance="fill" class="calendar-date-range">-->
  <!--    <mat-label>Enter a date range</mat-label>-->
  <!--    <mat-date-range-input [rangePicker]="picker">-->
  <!--      <input matStartDate formControlName="start" placeholder="Start date">-->
  <!--      <input matEndDate formControlName="end" placeholder="End date" (dateChange)="changeEndPickerDate()">-->
  <!--    </mat-date-range-input>-->
  <!--    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
  <!--    <mat-date-range-picker #picker></mat-date-range-picker>-->

  <!--    <mat-error *ngIf="dateFilterForm.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
  <!--    <mat-error *ngIf="dateFilterForm.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->
  <!--  </mat-form-field>-->

</div>


